var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import LinearGradient from 'react-native-linear-gradient';
import Image from '@24i/nxg-sdk-quarks/src/components/Image/index.web';
import { useEpgDataFilteredForNow, } from '@24i/nxg-sdk-smartott/src/screens/PlaybackScreen/managers';
import SingleRow from '@24i/nxg-sdk-gluons/src/components/containers/SingleRow/index.web';
import Packshot from '@24i/nxg-sdk-gluons/src/components/ui/Packshot/index.web';
import ProgressBar from '@24i/nxg-sdk-gluons/src/components/ui/ProgressBar';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import { SOTT_DEFAULT_WEB_SCREENS } from '@24i/nxg-sdk-smartott/src/navigation/constants';
import { modalType, getChannelProgress } from '@24i/player-ui';
import { CloseButton } from '../../components/CloseButton';
import { Container, PackshotHolder, getChannelPackshotStyle, getChannelsSingleRowStyle, linearGradientStyle, PACKSHOT_HEIGHT, PACKSHOT_WIDTH, } from './styled';
export const ChannelsModal = ({ epgData = { channels: [] }, }) => {
    const router = useRouter();
    const nowFilter = useEpgDataFilteredForNow();
    const filteredPrograms = nowFilter(epgData);
    const handleOnPress = (program, event) => __awaiter(void 0, void 0, void 0, function* () {
        const eventAsEvent = event;
        if (eventAsEvent.preventDefault)
            eventAsEvent.preventDefault();
        if (eventAsEvent.stopPropagation)
            eventAsEvent.stopPropagation();
        const { isCurrentlyPlaying, currentProgram: asset } = epgData.channels.find((channel) => { var _a; return ((_a = channel === null || channel === void 0 ? void 0 : channel.currentProgram) === null || _a === void 0 ? void 0 : _a.channelId) === (program === null || program === void 0 ? void 0 : program.channelId); });
        if (isCurrentlyPlaying)
            return;
        const { type, id } = asset;
        const assetLink = SOTT_DEFAULT_WEB_SCREENS.Playback.getLink({
            type,
            id,
        });
        router.replace({
            pathname: assetLink.href,
            query: { channelId: program.channelId },
        }, assetLink.as);
    });
    const renderChannelProgram = (props) => {
        const { item } = props || {};
        if (!item)
            return null;
        const currentChannel = epgData.channels.find((candidate) => { var _a; return ((_a = candidate === null || candidate === void 0 ? void 0 : candidate.currentProgram) === null || _a === void 0 ? void 0 : _a.channelId) === (item === null || item === void 0 ? void 0 : item.channelId); });
        const { isCurrentlyPlaying, channel } = currentChannel || {};
        const channelLogo = channel === null || channel === void 0 ? void 0 : channel.channelLogo;
        const broadcast = (item === null || item === void 0 ? void 0 : item.channelId) ? item : null;
        const progressBarRender = (progressProps) => (React.createElement(React.Fragment, null,
            React.createElement(LinearGradient, { key: "gradient", colors: ['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.7)'], style: linearGradientStyle }),
            React.createElement(ProgressBar, Object.assign({ key: "progressBar" }, progressProps))));
        return (React.createElement(PackshotHolder, { isCurrentlyPlaying },
            React.createElement(Packshot, Object.assign({}, props, { isSelected: isCurrentlyPlaying, isChannel: true, channelLogo: channelLogo, styles: getChannelPackshotStyle, progress: getChannelProgress(broadcast), actionIcon: undefined, title: item.title, renderImage: (imageProps) => (React.createElement(React.Fragment, null,
                    React.createElement(Image, Object.assign({}, imageProps)))), renderProgressBar: progressBarRender }))));
    };
    return (React.createElement(Container, null,
        React.createElement(CloseButton, { type: modalType.channels }),
        React.createElement(SingleRow, { onItemPress: handleOnPress, packshotHeight: PACKSHOT_HEIGHT, packshotWidth: PACKSHOT_WIDTH, key: "AllChannelRow", section: { items: filteredPrograms }, title: "All channels", styles: getChannelsSingleRowStyle, renderPackshot: renderChannelProgram })));
};
//# sourceMappingURL=index.js.map